const E = { createSampleReport: '+ Create New Report' };

const F = { createSampleReport: '+ Create New Report' };

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/splitReportsStep1.js